import _intersection from 'lodash.intersection'
import _includes from 'lodash.includes'
import { MONTHS } from '../../config/constants';

const _filterComponentByType = (addressComponents, types) => {
  for (const type of types) {
    for (const addressComponent of addressComponents) {
      if (addressComponent.types.includes(type)) {
        return addressComponent;
      }
    }
  }
  return null;
};

export const getAddress = (result) => {
  const cityTypes = ['administrative_area_level_2', 'locality', 'administrative_area_level_1'];
  const airportTypes = ['airport'];
  const addressComponents = result.address_components;
  const cityName = _filterComponentByType(addressComponents, cityTypes);
  const city = cityName && cityName.long_name;
  const isCity = _intersection(cityTypes, result.types).length > 0;
  const isAirport = _intersection(airportTypes, result.types).length > 0 || _includes(result.formatted_address.toLowerCase(), 'airport');
  const postalCode = _filterComponentByType(addressComponents, ['postal_code']);
  const pincode = postalCode && postalCode.short_name;
  let {lat, lng} = result.geometry.location;
  if (typeof lat === 'function') {
    lat = lat();
    lng = lng();
  }
  return {
    address: result.formatted_address,
    place_id: result.place_id,
    latitude: lat,
    longitude: lng,
    pincode,
    city,
    google_city: city,
    is_city: isCity,
    is_airport: isAirport
  };
};

export const getRandomNumber = () => {
  return Math.floor(Math.random() * 7) + 4;
}

/**
 * Formats a timestamp into a string with the format "DD Mon YYYY".
 * @param {string} time - The timestamp (in milliseconds) to be formatted.
 * @returns {string} The formatted date string in the format "DD Mon YYYY" (e.g., "27 Sept 2023").
 */
export const formatDate = (time, isYearIncluded) => {
  const date = new Date(parseFloat(time));
  if (isNaN(date)) {
      return '';
    }
  const day = String(date.getDate()).padStart(2, '0');
  const month = MONTHS[date.getMonth()];
  const year = String(date.getFullYear())
  if(isYearIncluded){
  return `${day} ${month} ${year}`;
  }
  return `${day} ${month}`
}

/**
* Formats a timestamp into a human-readable time string in 12-hour format with AM/PM.
* @param {string} time - The timestamp value to format.
* @returns {string} The formatted time string (e.g., "12:30 PM") or an empty string if the timestamp is falsy.
*/
export const formatTime = (time) => {
  const date = new Date(parseFloat(time));
  if (isNaN(date)) {
      return '';
  }
  const hours = date?.getHours();
  const minutes = date?.getMinutes();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const formattedTime = `${hours % 12 || 12}:${minutes < 10 ? '0' : ''}${minutes} ${ampm}`;
  return formattedTime;
}

/**
 * Formats a timestamp into a human-readable date and time string.
 * @param {Date} time - The timestamp value or Date object to format.
 * @returns {string} The formatted date and time string (e.g., "Jan 1, 2022, 12:30 PM") or an empty string if the provided time is invalid.
 */
export const formatDateTime = (time) => {
  const formattedDate = formatDate(time,false); 
  const formattedTime = formatTime(time);
  return `${formattedDate}, ${formattedTime}`;
}

export const filterPredictions = (predictions, query) => {
  return predictions
    .map((prediction) => {
      const mainText = prediction.structured_formatting.main_text;
      const secondaryText = prediction.structured_formatting.secondary_text ?
        prediction.structured_formatting.secondary_text : mainText;
      const name = `${mainText}, ${secondaryText}`;
      const matches = matchMainTextWithQuery(mainText, query);
      return {
        name,
        matches,
        mainText,
        secondaryText,
        placeId: prediction.place_id
      };
    });
};

const matchMainTextWithQuery = (mainText, query) => {
  const matchStart = mainText.toLowerCase().indexOf(query.toLowerCase());
  const matches = [];
  if (matchStart < 0) {
    matches.push({
      text: mainText,
      matched: false
    });
  } else {
    if (matchStart > 0) {
      matches.push({
        text: mainText.substring(0, matchStart),
        matched: false
      });
    }
    matches.push({
      text: mainText.substring(matchStart, matchStart + query.length),
      matched: true
    });
    if (matchStart + query.length < mainText.length) {
      matches.push({
        text: mainText.substring(matchStart + query.length, mainText.length + 1),
        matched: false
      });
    }
  }
  return matches;
};

/**
 * Creates an array of objects containing kiosk images based on provided kiosk details.
 * @param {object} kioskDetails - Object containing kiosk image details.
 * @param {string} kioskDetails.kioskDirectionImage - URL or path for the kiosk direction image.
 * @param {string} kioskDetails.kioskImage - URL or path for the kiosk image.
 * @returns {Array<object>} An array of objects representing kiosk images with labels and types.
 */

export const kioskImage = (kioskDetails)=>{
  const listItems = [];
  if (kioskDetails?.kioskDirectionImage && kioskDetails?.kioskDirectionImage !== "") {
      listItems.push({
        img: kioskDetails?.kioskDirectionImage,
        label: 'View Map',
        type: 'map'
      });
    }
    if (kioskDetails?.kioskImage && kioskDetails?.kioskImage !== '') {
      listItems.push({
        img: kioskDetails?.kioskImage,
        label: 'Kiosk Photo',
        type: 'img'
      });
    }
    return listItems;
  };

export const Strings = {
  helplineNumberTxt: 'CALL HELPLINE',
  driverNumberTxt: 'Call driver',
  label1: 'Share your OTP',
  label2: 'with the driver'
};

export const returnIds =()=>{
  const currentUrl = window.location.href;
  const url = new URL(currentUrl);
  const params = new URLSearchParams(url?.search);
  const refId = params?.get('refId');
  const bookingId = params?.get('bookingId');
  return {refId , bookingId}
} 